import(/* webpackMode: "eager" */ "/app/front_end/node_modules/next/dist/client/app-dir/link.js");
